/**
 * @file index.tsx
 * @author Arunkumar Annamalai
 * @version 1.0.0
 * @description Main entry point for the Shay Suite Admin React application.
 *              This file initializes the React application, renders the root App component,
 *              and sets up performance monitoring with Web Vitals.
 * @created Aug-2025
 * @lastModified Aug-2025
 */

import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Creates the root React element and renders the main App component
 * This is the entry point that bootstraps the entire React application
 */
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/**
 * Renders the main App component into the DOM
 * This starts the React application lifecycle
 */
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

/**
 * Initializes performance monitoring using Web Vitals
 * This function tracks Core Web Vitals metrics for performance optimization
 * Can be configured to send metrics to analytics services
 */
reportWebVitals();
